import { gql } from "apollo-boost";
import blocks from "blocks/query";
import { image, idtype } from "querypieces";
import resourceBuilder from "components/resource-builder/query";

export default gql`
  query($uri: String) {
    entry(uri: [$uri]) {
      ${idtype}
      ...on page_Entry {
        heroHead: longCopy
        headSubhead: richTextSimple
        heroImage: ${image}
        pageBuilder(level:1) {
          ${blocks}
        }
      }  
      ...on simplePage_Entry {
        title
        heading
        pageBuilder: resourceBuilder {
          ${resourceBuilder}
        }
      }
      ...on locale_Entry {
        title
        copy
        ${image}
        resourceOrganizations {
          ...on organization_Entry {
            id
            title
            logo {
              url
              width
              height
              alt
            }
            address
            website
            phoneNumber {
              url
              type
              defaultLabel
            }
            email
          }
        }
        pageBuilder(level:1) {
          ${blocks}
        }
      }
    }
  }
`;
